import i18n from "../../i18n";

export type JobOption = { outsideUsualJob?: boolean };

export type ShowAllLabels = { showAll: string, others: string };

export const TRUCK_LABELS: ShowAllLabels = {
  get showAll() { return i18n.t("showAll.trucks"); },
  get others() { return i18n.t("showAll.otherTrucks"); },
};

export const PLANT_MODEL_LABELS: ShowAllLabels = {
  get showAll() { return i18n.t("showAll.models"); },
  get others() { return i18n.t("showAll.otherModels"); },
};

export const LOADING_MACHINE_LABELS: ShowAllLabels = {
  get showAll() { return i18n.t("showAll.loadingMachines"); },
  get others() { return i18n.t("showAll.otherLoadingMachines"); },
};
